import { render, staticRenderFns } from "./kine-dashboard.vue?vue&type=template&id=47f328d3&scoped=true"
import script from "./kine-dashboard.vue?vue&type=script&lang=js"
export * from "./kine-dashboard.vue?vue&type=script&lang=js"
import style0 from "./kine-dashboard.vue?vue&type=style&index=0&id=47f328d3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f328d3",
  null
  
)

export default component.exports